import React from 'react';
import Immigration from '../immigration/Immigration';

const Visa = () => {
    return ( <Immigration/> );
}
 
export default Visa;